import { Section } from "../Section";
export const Home = () => {
  return (
    <Section>
      <h2> Home component</h2>
    </Section>
  );
};
